import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { forwardRef } from "react";
import styled from "styled-components";
import { NavLink } from "react-router-dom";
import PropTypes from "prop-types";
import { focusStyle, hoverStyle_noBorder, addIcon, activeStyle, extendedSystemStyles } from "@mixins";
import { isExternalLink } from "utils/links";
import { jsx as _jsx } from "react/jsx-runtime";
var styledSystemKeys = ["space", "layout", "flexbox", "typography", "color"];
var iconFunc = function iconFunc(theme, href, icon, marginCustom, marginOutgoing) {
  return icon ? addIcon(theme, icon, marginCustom) : isExternalLink(href) ? addIcon(theme, "externalLink", marginOutgoing) : "";
};
var Link = styled( /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx(NavLink, _objectSpread({
    ref: ref
  }, props));
})).withConfig({
  displayName: "Link",
  componentId: "sc-yyx5yq-0"
})(["&:after{padding-left:10px;", "}&:before{padding-right:10px;", "}", "", ""], function (_ref) {
  var theme = _ref.theme,
    align = _ref.align,
    href = _ref.href,
    icon = _ref.icon;
  return align !== "left" ? iconFunc(theme, href, icon, ".5rem 0 auto auto", ".3rem 0 auto auto") : "";
}, function (_ref2) {
  var theme = _ref2.theme,
    align = _ref2.align,
    href = _ref2.href,
    icon = _ref2.icon;
  return align === "left" ? iconFunc(theme, href, icon, ".5rem 0 auto 0", ".4rem 0 auto 0") : "";
}, function (_ref3) {
  var theme = _ref3.theme,
    inverted = _ref3.inverted,
    disabled = _ref3.disabled,
    to = _ref3.to;
  return "\n    font-family: ".concat(theme.fonts.robotoMedium, ";\n    font-size: ").concat(theme.fontSizes.md, ";\n    line-height: 2.2rem;\n    font-weight: normal;\n\n    min-height: ").concat(theme.actionStyles.height, ";\n    display: flex;\n    padding: 6px 20px 5px;\n    align-items: center;\n\n    outline: none;\n    text-decoration: none;\n    transition: all .3s;\n\n    color: ").concat(inverted && to !== "".concat(location.pathname).concat(location.search) ? theme.colors.i4 : theme.colors.P3, ";\n\n    ").concat(!disabled ? "\n      &:hover { ".concat(hoverStyle_noBorder(theme), " }\n      &:focus{ ").concat(focusStyle(theme), " }\n      ").concat(to === "".concat(location.pathname).concat(location.search) ? activeStyle(theme) : "", "\n    ") : "");
}, extendedSystemStyles(styledSystemKeys));
Link.propTypes = {
  to: PropTypes.any.isRequired,
  as: PropTypes.string,
  href: PropTypes.string,
  icon: PropTypes.string,
  align: PropTypes.oneOf(["left", "right"]),
  inverted: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string
};
export default Link;